import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.error)?_c(VAlert,{staticClass:"ma-8",attrs:{"type":"error"}},[_vm._v("\n    "+_vm._s(_vm.error)+"\n  ")]):_vm._e(),(_vm.loading)?_c(VProgressLinear,{attrs:{"indeterminate":""}}):_vm._e(),(!_vm.loading)?_c(VDataTable,{staticClass:"ma-4 table",attrs:{"disable-pagination":"","disable-filtering":"","disable-sort":"","dense":"","headers":_vm.headers,"items":_vm.items,"hide-default-footer":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }